import { useMemo } from 'react'
import { FAVORITTER, LUKKEDE_GRUPPER, useMenyvalg } from '../../hooks/useMenyvalg'
import { MenyvalgKontekst } from './menyvalgKontekst'

/**
 * Henter og lagrer menyvalgene én gang for hele skallet (DashboardLayout).
 *
 * `seksjoner`: menyen brukeren ser (getNavSections). `bruker`: app-brukerens
 * id. `aktiv`: favoritter og stjerne finnes (ikke for kunder, som har en kort
 * meny). `kanEndre`: false under «Se som», som bare er for lesing.
 */
export default function Menyvalg({ seksjoner, bruker, aktiv, kanEndre, children }) {
  const hvem = aktiv ? bruker : null
  const [favoritter, settFavoritter] = useMenyvalg(FAVORITTER, { bruker: hvem, kanLagre: kanEndre })
  const [lukkede, settLukkede] = useMenyvalg(LUKKEDE_GRUPPER, { bruker: hvem, kanLagre: kanEndre })
  const verdi = useMemo(
    () => ({ seksjoner, favoritter, settFavoritter, lukkede, settLukkede, aktiv: Boolean(aktiv && bruker), kanEndre }),
    [seksjoner, favoritter, settFavoritter, lukkede, settLukkede, aktiv, bruker, kanEndre],
  )
  return <MenyvalgKontekst.Provider value={verdi}>{children}</MenyvalgKontekst.Provider>
}
